import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const phoneNumberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const PHONE_PATTERN = /^\+?[1-9]\d{6,14}$/;
  if (!control.value) {
    return null;
  }
  return PHONE_PATTERN.test(control.value) ? null : { phone: true };
};
